import { Navigate } from 'react-router-dom';
import { buildPath } from './lib/tenant';

function App() {
    return <Navigate to={buildPath('/events')} replace />;
}

export default App;
